var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3535_301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.95514 31.0449 0 20 0C8.95514 0 0 8.95514 0 20C0 29.9817 7.31261 38.2562 16.8753 39.7581V25.7826H11.7958V20H16.8753V15.5927C16.8753 10.5808 19.8622 7.81043 24.4298 7.81043C26.6179 7.81043 28.9073 8.20138 28.9073 8.20138V13.1233H26.3845C23.901 13.1233 23.1247 14.6646 23.1247 16.2481V20H28.6711L27.7851 25.7826H23.1247V39.7581C32.6874 38.259 40 29.9845 40 20Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3535_301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.51311395b3463f2d805d730e57bfee02.svg";
export { ForwardRef as ReactComponent };